/**
 * Represents event argument for DataLegendSummaryCalculationCustom
*/
var IgrDataLegendSummaryEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrDataLegendSummaryEventArgs() {
    }
    Object.defineProperty(IgrDataLegendSummaryEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrDataLegendSummaryEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrDataLegendSummaryEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrDataLegendSummaryEventArgs.prototype, "columnValues", {
        /**
         * Gets actual values in the current a column
        */
        get: function () {
            return this.i.columnValues;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.columnValues = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendSummaryEventArgs.prototype, "columnMemberPath", {
        /**
         * Gets member path to identify a column
        */
        get: function () {
            return this.i.columnMemberPath;
        },
        set: function (v) {
            this.i.columnMemberPath = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendSummaryEventArgs.prototype, "summaryValue", {
        /**
         * Gets or sets summary values displayed below data column
        */
        get: function () {
            return this.i.summaryValue;
        },
        set: function (v) {
            this.i.summaryValue = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendSummaryEventArgs.prototype, "summaryUnits", {
        /**
         * Gets or sets text displayed or right side of SummaryValue
        */
        get: function () {
            return this.i.summaryUnits;
        },
        set: function (v) {
            this.i.summaryUnits = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendSummaryEventArgs.prototype, "summaryLabel", {
        /**
         * Gets or sets text displayed or left side of SummaryValue
        */
        get: function () {
            return this.i.summaryLabel;
        },
        set: function (v) {
            this.i.summaryLabel = v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrDataLegendSummaryEventArgs;
}());
export { IgrDataLegendSummaryEventArgs };
